
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-files",
      function () {
        return require("private-next-pages/data-files/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-files"])
      });
    }
  